import jQuery from 'jquery';
import _ from 'underscore';

let requestCache = {};
let maxRecursiveness = 3;

export default class GPlacesHelper {

  static createService(map) {
    let div = document.createElement('div');
    this.service = new google.maps.places.PlacesService(div);
    return this.service;
  }

  static searchNearby(map, options, i) {
    let indexRecursive = i || 0;
    let request = this._createRequest(options),
      service = this.service || this.createService(map),
      deferred = jQuery.Deferred();
    service.nearbySearch(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        deferred.resolve(results, status);
      } else if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
        if (indexRecursive < maxRecursiveness) {
          setTimeout(() => {
            indexRecursive++;
            this.searchNearby(map, options, indexRecursive).then((results, status) => {
              deferred.resolve(results, status);
            });
          }, 1000);
        } else {
          deferred.reject();
        }
      } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        deferred.resolve([], status);
      } else {
        deferred.reject();
      }
    });
    return deferred.promise();
  }

  static searchText(map, options, i) {
    let indexRecursive = i || 0;
    let deferred = jQuery.Deferred(),
      request = {},
      service = this.service || this.createService(map);
    request = this._createRequest(options);
    service.textSearch(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        deferred.resolve(results, status);
      } else if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
        if (indexRecursive < maxRecursiveness) {
          setTimeout(() => {
            indexRecursive++;
            this.searchText(map, options, indexRecursive).then((results, status) => {
              deferred.resolve(results, status);
            });
          }, 1000);
        } else {
          deferred.reject();
        }
      } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        deferred.resolve([], status);
      } else {
        deferred.reject();
      }
    });
    return deferred.promise();
  }

  static getDetails(map, places) {
    let deferred = jQuery.Deferred(),
      placeID = 'place_id',
      promises = [],
      arrayPlaces = [];

    arrayPlaces = this._normalizePlacesForRequest(places);

    _.each(arrayPlaces, (place) => {
      if (!_.isObject(requestCache[place[placeID]])) {
        let request = this._getDetails(map, place[placeID]);
        promises.push(request);
        requestCache[place[placeID]] = request;
      } else {
        promises.push(requestCache[place[placeID]]);
      }
    });
    jQuery.when.apply(jQuery, promises)
      .then(function() {
        deferred.resolve(arguments);
      }).fail(function(reason) {
        deferred.reject(reason);
      });
    return deferred.promise();
  }

  static _getDetails(map, placeID) {
    let _this = this,
      deferred = jQuery.Deferred(),
      request = {
        placeId: placeID
      },
      service = this.service || this.createService(map);

    service.getDetails(request, function(details, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        deferred.resolve(details);
      } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
        setTimeout(() => {
          _this._getDetails(map, placeID)
            .done((_details) => {
              deferred.resolve(_details);
            })
            .fail((_reason) => {
              deferred.reject(_reason);
            });
        }, 200);
      } else {
        deferred.reject('Request Fail');
      }
    });
    return deferred.promise();
  }

  static _normalizePlacesForRequest(source) {
    let placeID = 'place_id',
      arrayPlaces = [],
      arrayResult = [];

    arrayPlaces = _.isArray(source) ? source : [source];

    arrayResult = arrayPlaces.map((el) => {
      let place = {};
      if (!_.isObject(el)) {
        place[placeID] = el;
      } else {
        place = el;
      }
      return place;
    });

    return arrayResult;
  }

  static _createRequest(options) {
    let commonOpt = {
        bounds: options.bounds || null,
        location: options.location || null,
        radius: options.radius || null,
        openNow: options.opennow || null,
        minPriceLevel: options.minPriceLevel || null,
        maxPriceLevel: options.maxPriceLevel || null,
        keyword: options.keyword || null,
        name: options.name || null,
        type: options.type || null,
        types: options.types || null
      },
      othersOpt = {
        query: options.query,
        rankby: options.rankby || null,
      };

    return _.extend({}, commonOpt, othersOpt);
  }
}



// WEBPACK FOOTER //
// ./lmm-widget/src/helpers/GPlacesHelper.js